import { useEffect, useState } from "react";
import { PublicLayout } from "@/components/Layout";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle, Newspaper, ExternalLink } from "lucide-react";

const CATS = ["Todas","Cardiologia","Odontologia","Psicologia","Nutrição","Fisioterapia","Prevenção","Bem-estar"];

export default function Noticias() {
  const [cat, setCat] = useState("Todas");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    setLoading(true);
    api.get("/news",{params:{specialty: cat}}).then(r=>setData(r.data)).finally(()=>setLoading(false));
  }, [cat]);

  return (
    <PublicLayout>
      <section className="gs-warm-bg py-14">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-xs uppercase tracking-widest text-[#FF7D54] font-semibold flex items-center gap-2"><Newspaper className="w-4 h-4"/>Notícias diárias</div>
          <h1 className="text-3xl sm:text-4xl font-extrabold" style={{fontFamily:"Plus Jakarta Sans"}}>Saúde em movimento</h1>
          <p className="mt-3 text-slate-600 max-w-2xl">Manchetes atualizadas todos os dias sobre saúde, prevenção e as principais especialidades atendidas pela rede GIRO+SAÚDE.</p>
          <div className="mt-6 flex flex-wrap gap-2">
            {CATS.map(c=>(
              <button key={c} data-testid={`news-cat-${c}`} onClick={()=>setCat(c)}
                className={`px-3 py-1.5 rounded-full text-sm border ${cat===c?"bg-[#0D7C66] text-white border-[#0D7C66]":"bg-white text-slate-700 border-slate-200 hover:border-[#0D7C66]"}`}>
                {c}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-10">
        {loading && <div className="text-slate-500">Carregando…</div>}
        {!loading && data && !data.configured && (
          <Card className="p-6 border-amber-200 bg-amber-50 flex gap-3" data-testid="news-not-configured">
            <AlertCircle className="w-6 h-6 text-amber-600 shrink-0"/>
            <div>
              <div className="font-semibold text-amber-900">Integração de notícias ainda não configurada</div>
              <div className="text-sm text-amber-800 mt-1">Adicione sua chave <b>NEWS_API_KEY</b> em <code>backend/.env</code> (obtida em <a href="https://newsapi.org/register" target="_blank" rel="noreferrer" className="underline">newsapi.org/register</a>) para ativar o feed diário.</div>
            </div>
          </Card>
        )}
        {!loading && data?.configured && data.articles?.length === 0 && (
          <div className="text-slate-500 text-center py-16">Nenhuma notícia encontrada para "{cat}" hoje.</div>
        )}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {data?.articles?.map((a,i)=>(
            <a key={i} href={a.url} target="_blank" rel="noreferrer" data-testid={`news-${i}`} className="group rounded-2xl overflow-hidden bg-white border border-slate-200 gs-shadow hover:-translate-y-0.5 transition">
              {a.image && <img src={a.image} alt="" onError={(e)=>{e.currentTarget.style.display='none';}} className="h-44 w-full object-cover"/>}
              <div className="p-5">
                <Badge className="bg-[#E6F4F1] text-[#0D7C66] border-0 mb-2">{a.source || "Fonte"}</Badge>
                <div className="font-semibold text-lg leading-snug group-hover:text-[#0D7C66]">{a.title}</div>
                {a.description && <div className="text-sm text-slate-500 mt-2 line-clamp-3">{a.description}</div>}
                <div className="text-xs text-slate-400 mt-3 flex items-center gap-1">
                  {a.publishedAt && new Date(a.publishedAt).toLocaleDateString("pt-BR")}
                  <ExternalLink className="w-3 h-3 ml-auto"/>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
